module.exports = __webpack_public_path__ + "img/kp3r.24862083.svg";